import { ChatId } from 'src/app/store/samwin/chats/models/chat-id';
import { ChatMessageSender } from './chat-message-sender';
import { CommandWithPayload } from './command';

export class UpdateLastMessageCommand extends CommandWithPayload<UpdateLastMessageCommandPayload> {
   public static readonly commandType: string = 'samwin/update-last-message';

   public constructor(public chatId: ChatId, public payload: UpdateLastMessageCommandPayload) {
      super(UpdateLastMessageCommand.commandType, chatId, payload);
   }
}

export class UpdateLastMessageCommandPayload {
   public constructor(public text: string, public timestamp: Date, public sender: ChatMessageSender) {
      // nothing to do
   }
}
